import React from 'react';

const CustomerStories = () => {
    return (
        <div className="min-h-screen flex items-center justify-center">
            <h1 className="text-3xl font-bold bg-gradient-to-r from-teal-400 to-green-300 bg-clip-text text-transparent">Customer Stories</h1>
        </div>
    );
};

export default CustomerStories;